export enum SponsorChangeType {
    GENERALSPONSOR = 'C'
}

export enum SponsorType {
    General_Sponsor_Change = 0
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/sponsor-change-type.enum.ts